export enum ServiceTypeEnum {
  Future = 'future',
  Past = 'past'
}
